import { editPermissionsConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const PermissionsActions = {
    permissionSearch,
};

function permissionSearch(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: editPermissionsConstants.EDIT_PERMISSIONS_REQUEST,
            data: null
        }));
        adminUsersServices.permissionSearch(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: editPermissionsConstants.EDIT_PERMISSIONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: editPermissionsConstants.EDIT_PERMISSIONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: editPermissionsConstants.EDIT_PERMISSIONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}